module.exports = __webpack_public_path__ + "e3fa659ec7382a66b10e5aa10a3c1c9c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/chest-close.png
// module id = BLwl
// module chunks = 0